export const config = {
	appBar: {
		color: 'white',
		height: 'auto',
		class: 'w-100'
	},
	innerSheet: {
		class: 'd-flex align-center'
	},
	spacer: {
		class: 'h-100 mr-4 mr-md-16'
	},
	menuBtn: {
		color: 'primary',
		minWidth: 0,
		height: '42px',
		spacing: 'px-1',
		text: true,
		class: 'text-caption'
	}
};
